<template>
  <div class="control-section toast-type-section">
    <div class="e-sample-resize-container">
      <ejs-toast
        ref="toastRef"
        id="toast_type"
        :position="position"
        :timeOut="timeOut"
        :target="target"
      ></ejs-toast>
    </div>
  </div>
</template>

<script>
export default {
  name: "Notification",
  props: {
    position: {
      type: Object,
      default: { X: "Right", Y: "Top" }
    },
    timeOut: {
      type: String,
      default: '5000'
    },
    target: document.body,
  },
  data() {
    return {
      obj: null
    };
  },
  mounted() {
    this.obj = this.$refs.toastRef.ej2Instances;
    console.log("NotificationObj:", this.obj);
  },
  methods: {
    toastShow(message) {
      this.obj.title = message.title || "";
      this.obj.content = message.content || "";

      this.$refs.toastRef.show();
    },
    info(message) {
      this.obj.cssClass = "e-toast-info";
      this.obj.icon = "e-info toast-icons";
      this.toastShow(message);
    },
    warning(message) {
      this.obj.cssClass = "e-toast-warning";
      this.obj.icon = "e-warning toast-icons";
      this.toastShow(message);
    },
    success(message) {
      this.obj.cssClass = "e-toast-success";
      this.obj.icon = "e-success toast-icons";
      this.toastShow(message);
    },
    error(message) {
      this.obj.cssClass = "e-toast-danger";
      this.obj.icon = "e-error toast-icons";
      this.toastShow(message);
    }
  }
};
</script>

<style>
</style>